"use client";

var __jsx = React.createElement;
import React, { useEffect, useState, useMemo } from "react";
import MuscleModal from "@modules/shared/components/modal";
import { MuscleButton } from "@modules/shared/components/buttons";
import { useCustomer } from "@lib/context/shared/customer-context";
import { useTranslations } from "next-intl";
import PlatformLogo from "@modules/shared/logos/platform-logo";
import { capitalizeFirstLetter } from "@lib/util/string-ops";
import promotionsService from "@lib/storyblok/services/promotions-service";
const PromotionsModal = () => {
  var _displayedPromotion$p, _displayedPromotion$p2;
  const {
    0: isOpen,
    1: setIsOpen
  } = useState(false);
  const {
    customerSegmentId
  } = useCustomer();
  const t = useTranslations("Shared");
  const {
    0: promotions,
    1: setPromotions
  } = useState([]);
  const displayedPromotion = useMemo(() => {
    return promotions[0];
  }, [promotions]);
  useEffect(() => {
    const fetchPromotions = async () => {
      if (customerSegmentId && customerSegmentId > 0) {
        try {
          const [segmentPromotions, generalPromotions] = await Promise.all([promotionsService.getPromotionsBySegmentId(customerSegmentId), promotionsService.getGeneralPromotions()]);
          const promotionsData = [...segmentPromotions, ...generalPromotions];
          if (Array.isArray(promotionsData) && promotionsData.length > 0) {
            setPromotions(promotionsData);
            setIsOpen(true);
          } else {
            setIsOpen(false);
          }
        } catch (error) {
          console.error("Error fetching promotions: ".concat(error.message));
          setIsOpen(false);
        }
      } else {
        setIsOpen(false);
      }
    };
    fetchPromotions();
  }, [customerSegmentId]);
  return __jsx(MuscleModal, {
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx("div", {
    className: "flex flex-col items-center text-center"
  }, __jsx("div", {
    className: "flex justify-center items-center w-full mb-[10px]"
  }, __jsx("p", {
    className: "text-xl font-semibold text-secondary-main"
  }, capitalizeFirstLetter(t("IN"))), __jsx(PlatformLogo, {
    containerClassName: "w-[130px]",
    height: 20
  })), __jsx("h1", {
    className: "text-xl font-semibold text-secondary-main mb-3"
  }, displayedPromotion === null || displayedPromotion === void 0 ? void 0 : displayedPromotion.title), __jsx("h2", {
    className: "text-base text-primary-main"
  }, displayedPromotion === null || displayedPromotion === void 0 ? void 0 : displayedPromotion.subtitle), __jsx("div", {
    className: "w-full items-center flex justify-center mb-5"
  }, __jsx("img", {
    src: displayedPromotion === null || displayedPromotion === void 0 || (_displayedPromotion$p = displayedPromotion.promotion_image) === null || _displayedPromotion$p === void 0 ? void 0 : _displayedPromotion$p.filename,
    alt: (displayedPromotion === null || displayedPromotion === void 0 || (_displayedPromotion$p2 = displayedPromotion.promotion_image) === null || _displayedPromotion$p2 === void 0 ? void 0 : _displayedPromotion$p2.alt) || (displayedPromotion === null || displayedPromotion === void 0 ? void 0 : displayedPromotion.title),
    className: "w-[276.34px] h-[211px] object-cover mb-5"
  })), __jsx("p", {
    className: "text-base font-light text-primary_text mb-8"
  }, displayedPromotion === null || displayedPromotion === void 0 ? void 0 : displayedPromotion.description), __jsx(MuscleButton, {
    onClick: () => setIsOpen(false),
    text: t("Actions.UNDERSTAND"),
    className: "w-full"
  })));
};
export default PromotionsModal;